import { createReducer } from 'redux-act';
import Immutable from 'seamless-immutable';

import Account from './account-model';
import AccountActions from './account-actions';

const initialState = Immutable({
  active:           Account.deserialize(App.globalContext.account),
  relativeAccounts: {
    byId: {},
  },
});

const reducer = createReducer((on) => {
  on([AccountActions.fetchCurrentAccountSuccess, AccountActions.saveCurrentAccountSuccess], (state, { account }) =>
    state.set('active', account)
  );

  // Ensure that when the account is updated, we don't lose any existing Account API data
  on(AccountActions.saveCurrentAccountSuccess, (state, { account }) =>
    state.setIn(['active', 'apiData'], state.active.apiData)
  );

  on([AccountActions.updateCurrentAccountProperty], (state, { id, value }) => state.setIn(['active', id], value));

  on(AccountActions.fetchRelativeAccountsSuccess, (state, { accountList }) => {
    const byId = _.reduce(
      accountList,
      (acc, form) => {
        acc[form.id] = form;
        return acc;
      },
      {}
    );

    return state.setIn(['relativeAccounts', 'byId'], byId);
  });

  on(AccountActions.fetchAccountApiDataSuccess, (state, { accountApiData }) => {
    // Merge account details (apikeys, etc.) into the active account
    return state.setIn(['active', 'apiData'], accountApiData);
  });
}, initialState);

export default reducer;
